import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteGroupById } from "../services/groups.service";
import { QueryKeys } from "./queryKeys";
import useFlag, { FLAGS } from "../../../hooks/useFlag";
import { useMediaTaskTypeIds } from "@coworker/apprestructured/src/task-management/services/useMediaTaskTypeIds";
import { removeTaskDetailsReference } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { getMediaItemsWithTasksQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";

export const useDeleteGroupById = () => {
  const queryClient = useQueryClient();
  const [storedMediaId, setStoredMediaId] = useState<string>("");
  const enableMediaV2Tasks = useFlag(FLAGS.ENABLE_MEDIA_V2_TASKS);
  const mediaTaskTypeIds = useMediaTaskTypeIds();

  return useMutation({
    mutationFn: async ({
      groupId,
      mediaId,
    }: {
      groupId: string;
      mediaId: string;
    }) => {
      setStoredMediaId(mediaId);
      if (enableMediaV2Tasks) {
        await removeTaskDetailsReference(
          { media_id: mediaId, group_id: groupId },
          mediaTaskTypeIds
        );
      }
      return deleteGroupById(groupId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.GroupsByMedia, storedMediaId],
      });
      if (enableMediaV2Tasks) {
        queryClient.invalidateQueries({ queryKey: ["media-task-counts-v2"] });
        queryClient.invalidateQueries({
          queryKey: getMediaItemsWithTasksQueryKey(storedMediaId),
        });
      }
    },
  });
};
